export default __webpack_public_path__ + "static/media/ic_play.d15944bc.svg";